import axios from 'axios';

import { Component, Components, ComponentsData } from '@rta/rta-blueprint-library';

export type GetProductsParams <D>= {
	// data
	fileName: string,
	// token
	getToken: () => Promise<string>,
	// callbacks
	setState?: (data: D) => void,
	setError?: (error: string) => void
};

export const getProducts = async <D> (params: GetProductsParams<D>): Promise<D | null> => {
	const { fileName, getToken, setState, setError } = params;

	try {
		const token = await getToken();
		const response = await axios.get(`${import.meta.env.VITE_API_URL}/products/${fileName}`, {
			headers: {
				Authorization: `Bearer ${token}`
			}
		});

		// Assuming your API returns an array of component data objects
		const data = response.data as D;
		console.log('Component:API:return', data);

		if (response.status !== 200) {
			if (setError) setError(response.data);
			return null;
		}

		if (setState) setState(data);
		return data;
	} catch (error) {
		if (setError) setError(error as string);
		return null;
	}
};
